import { Injectable } from '@angular/core';
import { HttpLikesService } from '@services/HttpServices/LikesHttpService/http-likes.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LikesService {
  isPostsLoadingSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  isPostsLoading$: Observable<boolean> = this.isPostsLoadingSubject.pipe(map(count => count > 0));
  isLoadingSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  isLoading$: Observable<boolean> = this.isLoadingSubject.pipe(map(count => count > 0));

  constructor(private likesHttpService: HttpLikesService) { }

  likePost(postId: number) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.likesHttpService.likePost(postId).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  unlikePost(postId: number) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.likesHttpService.unlikePost(postId).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  likeReply(replyId: number){
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.likesHttpService.likeReply(replyId).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  unlikeReply(replyId: number) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.likesHttpService.unlikeReply(replyId).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  getPostLikesById(replyId: number) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.likesHttpService.getPostLikesById(replyId).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  getReplyLikesById(replyId: number) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.likesHttpService.getReplyLikesById(replyId).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }
}
